(function () {
    'use strict';

    function closePopup(popup) {
        if (popup) {
            popup.classList.remove('is-open');
            setTimeout(function () {
                if (popup._restore && !popup.classList.contains('is-open')) {
                    popup._restore();
                }
            }, 300); // Wait for transition to finish
        }
    }

    function initBtn(btn) {
        if (btn.dataset.pcsInit) return;
        btn.dataset.pcsInit = 'true';

        /* ── Find popup via traversal (robust against ID duplication) ── */
        var container = btn.parentElement;
        var popup = container ? container.querySelector('.pcs-popup') : null;

        /* Fallback to ID */
        if (!popup) {
            var popupId = btn.dataset.popup;
            if (popupId) popup = document.getElementById(popupId);
        }

        if (!popup) return;

        /* store popup reference for easy access if needed */
        btn._pcsPopup = popup;

        /* ── Open popup ── */
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            /* Close other open popups */
            document.querySelectorAll('.pcs-popup.is-open').forEach(function (p) {
                if (p !== popup) {
                    p.classList.remove('is-open');
                    if (p._restore) p._restore();
                }
            });

            /* Mobile Portal Strategy */
            if (window.innerWidth <= 768) {
                var originalParent = popup.parentElement;
                var placeholder = document.createComment('pcs-popup-placeholder');

                if (originalParent !== document.body) {
                    originalParent.insertBefore(placeholder, popup);
                    document.body.appendChild(popup);

                    /* Lock background scroll */
                    document.body.style.overflow = 'hidden';

                    popup._restore = function () {
                        /* Unlock background scroll */
                        document.body.style.overflow = '';

                        if (placeholder.parentElement) {
                            placeholder.parentElement.insertBefore(popup, placeholder);
                            placeholder.parentElement.removeChild(placeholder);
                        } else if (originalParent) {
                            originalParent.appendChild(popup);
                        }
                        popup._restore = null;
                    };
                }
            }

            // Force reflow
            void popup.offsetWidth;
            popup.classList.add('is-open');
        });

        /* ── Close button ── */
        var closeBtn = popup.querySelector('[data-close]');
        if (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                closePopup(popup);
            });
        }

        /* ── Find the hidden original theme size container. ── */
        var hiddenGrid = container ? container.querySelector('.pcs-hidden-sizes .product-card-sizes') : null;

        /* ── Size row click → click the matching hidden theme element ── */
        popup.querySelectorAll('.pcs-popup__size-row:not(.pcs-popup__size-row--unavailable)')
            .forEach(function (row) {
                row.addEventListener('click', function () {
                    if (row.classList.contains('is-loading')) return;

                    var size = row.dataset.value;

                    if (hiddenGrid) {
                        /* Find the matching .product-card-sizes--size */
                        var match = null;
                        hiddenGrid.querySelectorAll('.product-card-sizes--size').forEach(function (el) {
                            var spanText = el.querySelector('span') ? el.querySelector('span').textContent.trim() : '';
                            var dataSize = el.dataset.size || '';
                            if (spanText === size || dataSize === size) match = el;
                        });

                        if (match) {
                            /* 1. Click the theme element FIRST */
                            match.style.pointerEvents = 'auto';
                            match.click();
                            match.style.pointerEvents = '';

                            /* 2. Close popup right after */
                            closePopup(popup);
                            return;
                        }
                    }

                    /* ── Fallback: direct fetch ── */
                    var sizesEl = popup.querySelector('.pcs-popup__sizes');
                    var scriptEl = container && container.querySelector('.pcs-hidden-sizes script[type="application/json"]');
                    var variants = null;
                    try { if (scriptEl) variants = JSON.parse(scriptEl.textContent); } catch (e) { }

                    if (!variants) { return; }

                    var optIdx = parseInt(sizesEl.dataset.index, 10);
                    var optVals = (sizesEl.dataset.options || '').split(',').map(function (v) { return v.trim(); });
                    var opts = optVals.slice();
                    opts[optIdx] = size;

                    var variant = variants.find(function (v) {
                        return v.options.every(function (o, i) { return !opts[i] || o === opts[i]; });
                    }) || variants.find(function (v) {
                        return v.options[optIdx] === size && v.available;
                    });

                    if (!variant) { return; }

                    /* Close popup immediately, start fetch */
                    closePopup(popup);

                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                        body: JSON.stringify({ id: variant.id, quantity: 1 })
                    })
                        .then(function (r) { return r.json(); })
                        .then(function () {
                            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
                            document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
                            var d = document.querySelector('cart-drawer');
                            if (d && typeof d.open === 'function') try { d.open(); } catch (e) { }
                        })
                        .catch(function (err) {
                            console.error('[PCS] cart/add.js failed:', err);
                        });
                });
            });
    }

    /* Close on outside click */
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.pcs-popup') && !e.target.closest('.pcs-plus-btn')) {
            document.querySelectorAll('.pcs-popup.is-open').forEach(function (p) {
                closePopup(p);
            });
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            document.querySelectorAll('.pcs-popup.is-open').forEach(function (p) {
                closePopup(p);
            });
        }
    });

    function initAll() {
        document.querySelectorAll('.pcs-plus-btn').forEach(initBtn);
    }

    /* Expose global init function */
    window.initProductCardSizeOptions = initAll;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', initAll);

    new MutationObserver(function (m) {
        m.forEach(function (mut) {
            mut.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                if (node.querySelectorAll) node.querySelectorAll('.pcs-plus-btn').forEach(initBtn);
            });
        });
    }).observe(document.body, { childList: true, subtree: true });

}());
